import { Injectable } from '@angular/core';

/**
 * In-memory holder for the supplier's verified KYC magic-link token.
 *
 * Lifecycle:
 *   1. Submit page reads `?token=...` from the URL.
 *   2. Page calls KycTokenSubmissionService.verify(token) on load.
 *   3. On a 200 response the page stashes the token + the bundle context
 *      here so every subsequent service call (getByToken, upload, submit)
 *      can authenticate without re-asking the verify endpoint.
 *   4. Cleared on tab close (service is in-memory, not localStorage —
 *      deliberate so a closed tab can't be hijacked).
 *
 * The plain short token never leaves this service except as a request
 * field on the public endpoints. It's not persisted to localStorage,
 * sessionStorage, or any cookie.
 */
@Injectable({ providedIn: 'root' })
export class KycTokenAuthService {

  private token: string | null = null;
  private kycRequestId: number | null = null;
  private buyerId: number | null = null;
  private supplierId: number | null = null;

  set(payload: {
    token: string;
    kycRequestId: number;
    buyerId: number;
    supplierId: number;
  }): void {
    this.token = payload.token;
    this.kycRequestId = payload.kycRequestId;
    this.buyerId = payload.buyerId;
    this.supplierId = payload.supplierId;
  }

  getToken(): string | null {
    return this.token;
  }

  getKycRequestId(): number | null {
    return this.kycRequestId;
  }

  getBuyerId(): number | null {
    return this.buyerId;
  }

  getSupplierId(): number | null {
    return this.supplierId;
  }

  clear(): void {
    this.token = null;
    this.kycRequestId = null;
    this.buyerId = null;
    this.supplierId = null;
  }
}
